import React, { useCallback } from 'react';
import { ModalBody } from 'react-bootstrap';

import type { ICreateFolderModalConfig, IEditFolderModalConfig } from '@/hooks/types';
import type { IFolderFormData } from './types';

import { useAppDispatch } from '@/hooks';
import { FolderForm } from './FolderForm';
import { createFolder, updateFolder } from '@/store/slices/resourcesSlice';

interface IFolderModalProps {
  modalConfig: ICreateFolderModalConfig | IEditFolderModalConfig;
  handleClose: () => void;
}

const FolderModal = ({ modalConfig, handleClose }: IFolderModalProps): React.ReactElement => {
  const dispatch = useAppDispatch();

  const handleSubmit = useCallback(
    async (data: IFolderFormData) => {
      handleClose();

      if (modalConfig.modalType === 'new') {
        const payload = {
          id: null,
          name: data.name,
          agentVisible: data.agentVisible,
          parentId: modalConfig.data.parentFolderId,
          clientId: modalConfig.data.clientId,
          type: modalConfig.data.folderType,
        };

        await dispatch(createFolder(payload));
      }

      if (modalConfig.modalType === 'edit') {
        const payload = {
          id: modalConfig.data.folderId,
          name: data.name,
          agentVisible: data.agentVisible,
          parentId: modalConfig.data.parentFolderId,
          clientId: modalConfig.data.clientId,
          type: modalConfig.data.folderType,
        };

        await dispatch(updateFolder(payload));
      }
    },
    [dispatch, handleClose, modalConfig],
  );

  return (
    <ModalBody>
      <FolderForm
        onCancel={handleClose}
        data={modalConfig.modalType === 'new' ? undefined : modalConfig.data}
        folderType={modalConfig.data.folderType}
        onSubmit={handleSubmit}
      />
    </ModalBody>
  );
};

export { FolderModal };
